import { INTEGRATION_TYPE_1C, type ReactFeatureComponent } from '#shared/lib/integrations';
import { InventoryFeatureCompareParametersRowContent } from './components/InventoryFeatureCompareParametersRowContent';
import { useGetIntegrationSettings } from '../../hooks/useGetIntegrationSettings';

export const InventoryFeatureCompareParametersRow: ReactFeatureComponent = (props) => {
    const { data: integrationSettings } = useGetIntegrationSettings();

    if (integrationSettings?.system_type !== INTEGRATION_TYPE_1C) {
        return null;
    }

    return <InventoryFeatureCompareParametersRowContent {...props} />;
};
